import script from "./Statements.vue?vue&type=script&setup=true&lang=ts"
export * from "./Statements.vue?vue&type=script&setup=true&lang=ts"

import "./Statements.vue?vue&type=style&index=0&id=115d3591&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-115d3591"]])

export default __exports__